"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyViewLayout = void 0;
var react_1 = require("react");
var constants_1 = require("../../shared/constants");
var getViewportWidth = function () {
    if (typeof window === 'undefined') {
        return constants_1.STRATEGY_BUILDER_LAYOUT_BREAKPOINT;
    }
    return window.innerWidth;
};
/**
 * Tracks viewport width and resolves the effective {@link StrategyViewLayout},
 * locking to the compact layout below {@link STRATEGY_BUILDER_LAYOUT_BREAKPOINT}.
 */
exports.useStrategyViewLayout = function () {
    var _a = react_1.useState(getViewportWidth), viewportWidth = _a[0], setViewportWidth = _a[1];
    var _b = react_1.useState('default'), preferredViewLayout = _b[0], setPreferredViewLayout = _b[1];
    react_1.useEffect(function () {
        if (typeof window === 'undefined') {
            return undefined;
        }
        var handleResize = function () {
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var isViewLayoutLocked = viewportWidth < constants_1.STRATEGY_BUILDER_LAYOUT_BREAKPOINT;
    var viewLayout = isViewLayoutLocked ? constants_1.STRATEGY_BUILDER_COMPACT_LAYOUT : preferredViewLayout;
    var handleSetPreferred = function (layout) {
        if (isViewLayoutLocked)
            return;
        setPreferredViewLayout(layout);
    };
    return {
        viewLayout: viewLayout,
        isViewLayoutLocked: isViewLayoutLocked,
        setPreferredViewLayout: handleSetPreferred,
    };
};
